import React from "react";
import { Button, Modal, Radio } from "antd";
import riskStatusLogo from "../../assets/images/popup_logos/risk_status_logo.svg";
import "./styles.css";

const RiskRatingModal = ({
  isOpen,
  onCancel,
  onSubmit,
  value,
  onChange,
  submitLoading,
  getRiskColor
}) => {
  const riskOptions = [
    { label: "High Risk", value: "HIGH_RISK", color: "red" },
    { label: "Moderate Risk", value: "MODERATE_RISK", color: "orange" },
    { label: "Low Risk", value: "LOW_RISK", color: "goldenrod" },
    { label: "No Risk", value: "NO_RISK", color: "green" },
  ];

  return (
    <Modal 
      open={isOpen} 
      footer={null} 
      closable={false}
      className="risk-rating-modal"
      style={{ top: 20 }}
    >
      <div className="risk-modal-container">
        {/* Celebration Icon */}
        <div className="risk-icon-container">
          <img 
            src={riskStatusLogo} 
            alt="Celebration" 
            className="risk-icon-img"
          />
        </div>
        
        {/* Title */}
        <h3 className="risk-main-title">
          Great! Please rate the user profile
        </h3>
        
        {/* Subtitle */}
        <h4 className="risk-subtitle">
          Rate Risk Status
        </h4>
        
        {/* Instruction */}
        <p className="risk-instruction">
          Based on your assessment, select the member's risk status:
        </p>
        
        {/* Radio Group */}
        <Radio.Group
          onChange={onChange}
          value={value}
          className="risk-radio-group"
        >
          <div className="risk-radio-container">
            <Radio value="NO_RISK" className="risk-radio-item" data-value="NO_RISK">
              <span className="risk-radio-label">No Risk</span>
            </Radio>
            <Radio value="LOW_RISK" className="risk-radio-item" data-value="LOW_RISK">
              <span className="risk-radio-label">Low</span>
            </Radio>
            <Radio value="MODERATE_RISK" className="risk-radio-item" data-value="MODERATE_RISK">
              <span className="risk-radio-label">Moderate</span>
            </Radio>
            <Radio value="HIGH_RISK" className="risk-radio-item" data-value="HIGH_RISK">
              <span className="risk-radio-label">High</span>
            </Radio>
          </div>
        </Radio.Group>
        
        <style>
          {`
            .risk-radio-item .ant-radio-checked .ant-radio-inner {
              background-color: ${value ? getRiskColor(value) : '#d9d9d9'} !important;
              border-color: ${value ? getRiskColor(value) : '#d9d9d9'} !important;
            }
            .risk-radio-item .ant-radio-checked .ant-radio-inner::after {
              background-color: ${value ? getRiskColor(value) : '#d9d9d9'} !important;
            }
          `}
        </style>
        
        {/* Buttons */}
        <div className="risk-buttons-container">
          <Button 
            className="risk-btn-outline"
            onClick={onCancel}
          >
            Cancel
          </Button>
          <Button 
            className="risk-btn-primary"
            onClick={onSubmit}
            loading={submitLoading}
          >
            {submitLoading ? "Please wait..." : "Submit"}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default RiskRatingModal;